import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Ana_Title } from '../../../../../utils/EN/Modals/VideoModals';

const ModalVideoAna = () => {
  return (
    <>
      <ModalVideo
        id="ana-videoclips"
        dataText={Ana_Title}
        videoSrc="https://player.vimeo.com/video/284027407?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_ANA"
      />
    </>
  );
};

export default ModalVideoAna;
